import React from "react";

export const LoadingTable: React.FC = () => {
  return (
    <>
      <div className="candidate-list__table__row__skeleton">
        <div className="skeleton"></div>
        <div className="skeleton"></div>
      </div>
      <div className="candidate-list__table__row__skeleton">
        <div className="skeleton"></div>
        <div className="skeleton"></div>
      </div>
      <div className="candidate-list__table__row__skeleton">
        <div className="skeleton"></div>
        <div className="skeleton"></div>
      </div>
      <div className="candidate-list__table__row__skeleton">
        <div className="skeleton"></div>
        <div className="skeleton"></div>
      </div>
    </>
  );
};
